import { render, staticRenderFns } from "./ProvinceRanking.vue?vue&type=template&id=6488b5d8&scoped=true"
import script from "./ProvinceRanking.vue?vue&type=script&lang=js"
export * from "./ProvinceRanking.vue?vue&type=script&lang=js"
import style0 from "./ProvinceRanking.vue?vue&type=style&index=0&id=6488b5d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488b5d8",
  null
  
)

export default component.exports